import { useState } from "react";

export const useModal = (initState = false) => {
  const [isOpen, setIsOpen] = useState(initState);
  const [popoverAnchorEl, setPopoverAnchorEl] = useState(null);

  function handleClick(event, target) {
    setIsOpen(true);
    if (event) setPopoverAnchorEl(event.currentTarget);
    else if (target) setPopoverAnchorEl(target.current);
  }

  function handleClose() {
    setIsOpen(false);
    setPopoverAnchorEl(null);
  }

  return [isOpen, handleClick, handleClose, popoverAnchorEl];
};

export default useModal;
